<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="container login-page">
      <div v-if="errorMessage.length" class="row justify-content-center">
        <div class="col-md-12 col-lg-8">
          <base-alert class="text-center" type="danger" v-html="errorMessage"></base-alert>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4 ml-auto">
          <div class="info-area info-horizontal">
            <div class="icon icon-warning">
              <i class="tim-icons icon-alert-circle-exc"></i>
            </div>
            <div class="description">
              <h3 class="info-title">Password Change Required</h3>
              <p class="description">
                The HSP requires you to change your password to a more secure,
                private password. All passwords are securely stored and hashed
                and cannot be viewed by anyone, including system administrators.
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 mr-auto">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(changePassword)">
              <card class="card-login card-white">
                <template slot="header">
                  <img src="img/card-primary.png" alt="Background" />
                  <h1 class="card-title">Password</h1>
                </template>

                <div class="mt-4">
                  <validation-provider :rules ="{ requiredPassword: true }" v-slot="{ errors, untouched }">
                    <h6 v-if="errors.length && !untouched" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="password"
                      type="password"
                      placeholder="Current Password"
                      addon-left-icon="tim-icons icon-lock-circle"
                      v-model="password">
                    </base-input>
                  </validation-provider>
                </div>

                <div>
                  <validation-provider :rules ="{ requiredPassword: true }" v-slot="{ errors, untouched }" vid="confirmation">
                    <h6 v-if="errors.length && !untouched" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="newPassword"
                      type="password"
                      placeholder="Password"
                      addon-left-icon="tim-icons icon-lock-circle"
                      v-model="newPassword">
                    </base-input>
                  </validation-provider>
                </div>

                <div>
                  <validation-provider :rules ="{ requiredPassword: true, passwordConfirmed: { target: 'confirmation'} }" v-slot="{ errors, untouched }">
                    <h6 v-if="errors.length && !untouched" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="newPassword2"
                      type="password"
                      placeholder="Confirm Password"
                      addon-left-icon="tim-icons icon-lock-circle"
                      v-model="newPassword2">
                    </base-input>
                  </validation-provider>
                </div>

                <div slot="footer">
                  <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                    Submit
                  </base-button>
                </div>
              </card>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters, mapMutations } from 'vuex';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import { changePassword } from 'src/modules/adminActions';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
    },
    data() {
      return {
        password: null,
        newPassword: null,
        newPassword2: null,
        errorMessage: '',
        loading: false
      }
    },
    computed: {
      ...mapGetters(['adminUser'])
    },
    methods: {
      changePassword() {
        this.loading = true;
        this.errorMessage = '';

        changePassword({
          username: this.adminUser.username,
          password: this.password,
          newPassword: this.newPassword
        })
        .then(response => {
          this.handleIdentityResult(response.data);
        })
        .finally(() => {
          this.loading = false;
        })
      },
      ...mapMutations([
        'removeRedirectRoute',
        'removeAuthenticatedUser'
      ]),
      handleIdentityResult(identityResult) {
        if(identityResult.errors && identityResult.errors.length) {
          identityResult.errors.forEach(error => {
            this.errorMessage += `${error.description}<br>`
          });
        }
        else {
          this.removeRedirectRoute();
          let path = '/admin/surveys';
          this.$router.push({ path: path });
        }
      }
    }
  }
</script>
<style scoped>
  .login-page .card-login .card-header .card-title {
    font-size: 4em;
  }
</style>
